import apiClient from "@/api/apiClient";
import backendClient from "@/api/backendClient";
import { type WorkspaceInvitation } from "@/supabase.types";
import { spawnDeleteApiFunction, type ApiResourceConfig } from "@/utils/api";

import type { WorkspaceInvitationCreate } from "@waku-care/types/contracts/internal";

const table = "workspace_invitations";
const query = "*";
export const apiConfigWorkspaceInvitations: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["email", "user_name", "workspace_name", "workspace_role"],
  sortables: ["created_at", "email", "updated_at", "user_name", "workspace_role"],
};

export const getCurrentWorkspaceInvitations = async (workspace_id: string): Promise<WorkspaceInvitation[]> => {
  const { data, error } = await apiClient.from(table).select(query).eq("workspace_id", workspace_id);
  if (error) throw error;
  return data;
};

export const getWorkspaceInvitationsInvited = async (email: string): Promise<WorkspaceInvitation[]> => {
  const { data, error } = await apiClient.from(table).select(query).eq("email", email);
  if (error) throw error;
  return data;
};

export const createWorkspaceInvitation = async (body: WorkspaceInvitationCreate) => {
  const { data, error } = await backendClient.post<WorkspaceInvitation>("/workspace-invitations", { body });
  if (error) throw error;
  return data;
};

export const acceptWorkspaceInvitation = async (invitation_id: string) => {
  const { error } = await apiClient.rpc("accept_workspace_invitation", { invitation_id });
  if (error) throw error;
};

export const declineWorkspaceInvitation = async (invitation_id: string) => {
  const { error } = await apiClient.rpc("decline_workspace_invitation", { invitation_id });
  if (error) throw error;
};

export const deleteWorkspaceInvitation = spawnDeleteApiFunction({ table });
